(()=>{
  if(window.ecoMotion)return;
  window.ecoMotion=1;
  const reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  let io;
  if(!reduce&&('IntersectionObserver'in window)){
    io=new IntersectionObserver((entries)=>{
      entries.forEach((entry)=>{
        if(!entry.isIntersecting)return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    },{rootMargin:'0px 0px -8% 0px'});
  }
  const seen=(el)=>{
    const r=el.getBoundingClientRect();
    const h=window.innerHeight||document.documentElement.clientHeight||0;
    const w=window.innerWidth||document.documentElement.clientWidth||0;
    return r.bottom>0&&r.top<h&&r.right>0&&r.left<w;
  };
  const scan=(root)=>{
    const scope=root&&root.querySelectorAll?root:document;
    const cards=scope.matches&&scope.matches('[id$="__product_list_fa6P9H"]')
      ?scope.querySelectorAll('.resource-list__item')
      :scope.querySelectorAll('[id$="__product_list_fa6P9H"] .resource-list__item');
    cards.forEach((el,i)=>{el.classList.add('reveal');el.style.setProperty('--i',String(i));});
    if(reduce||!io)return;
    scope.querySelectorAll('.reveal:not(.is-in)').forEach((el)=>{
      if(seen(el)){el.classList.add('is-in');return;}
      el.classList.add('armed');
      io.observe(el);
    });
  };
  const run=()=>scan(document);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run,{once:true});
  else run();
  document.addEventListener('shopify:section:load',(event)=>scan(event.target));
})();
